// extracted by mini-css-extract-plugin
export default {"todo":"ItemStatus_todo__OzZ77","done":"ItemStatus_done__qRjrJ"};